import { StrictMode, Suspense, lazy } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import './styles/shell.css';
import { ErrorBoundary, PageLoading } from './chat/ErrorBoundary.jsx';

/**
 * Two pages, chosen by path. Not worth a router library: there is no nested
 * routing and every link is a plain <a> (see SideNav). nginx and Apache both
 * already fall back to index.html for unknown paths (deploy/), so /chat
 * resolves to this bundle in every environment.
 *
 * The chat page is lazy-loaded so the Search Programs page does not download it.
 */
const ChatPage = lazy(() => import('./chat/ChatPage.jsx'));
const isChat = /^\/chat\/?$/.test(window.location.pathname);

createRoot(document.getElementById('root')).render(
  <StrictMode>
    {isChat ? (
      <ErrorBoundary>
        <Suspense fallback={<PageLoading />}>
          <ChatPage />
        </Suspense>
      </ErrorBoundary>
    ) : <App />}
  </StrictMode>,
);
